import { createSelector } from '@reduxjs/toolkit';
import { UserAccessRight } from '../../../general/model';
import { Page } from '../../models/page';
import { getPage } from '../app/selectors';
import { getCurrentNode } from '../breadcrumbs/selectors';
import { NewFolderShape } from './model';

export const getNewFolder = (store: { newFolder: NewFolderShape }) => store.newFolder;

export const getIsOpen = createSelector(getNewFolder, (nf) => nf.isOpen);

export const getName = createSelector(getNewFolder, (nf) => nf.name);

export const getInProgress = createSelector(getNewFolder, (nf) => nf.inProgress);

export const getIsTriggerEnabled = createSelector(
  [getCurrentNode, getPage],
  (currentNode, page) => {
    if (page !== Page.FOLDER) {
      return false;
    }
    if (!currentNode) {
      return false;
    }
    return currentNode.perms.includes(UserAccessRight.write);
  },
);
